module.exports = __webpack_public_path__ + "img/ic_qr_smileys_mail.1afd69b9.svg";